import Box from "@mui/material/Box";

import TopBar from "@octopus-settings/components/common/topBar";
import SettingsTabs from "./settingsTabs";

import { SETTINGS_PAGE_WRAPPER_TEST_ID } from "@octopus-settings/constants/testIds/settingsPage";
import useStyles from "./SettingsPage.styles";

const SettingsPage = () => {
  const { classes } = useStyles();

  return (
    <Box
      className={classes.settingsPage}
      data-testid={SETTINGS_PAGE_WRAPPER_TEST_ID}
    >
      <TopBar />
      <Box className={classes.settingsContent}>
        <SettingsTabs />
      </Box>
    </Box>
  );
};

export default SettingsPage;
